import React from 'react';
import styled from 'styled-components';
import { configValidation } from '../../utils/cognitoConfig';

const AlertContainer = styled.div`
  background-color: #f8d7da;
  color: #721c24;
  padding: 1rem;
  margin: 1rem 0;
  border: 1px solid #f5c6cb;
  border-radius: 0.25rem;
  max-width: 800px;
  margin: 2rem auto;
`;

const AlertTitle = styled.h3`
  color: #721c24;
  margin-top: 0;
`;

const AlertList = styled.ul`
  margin-bottom: 0.5rem;
`;

const AlertItem = styled.li`
  margin-bottom: 0.25rem;
`;

const AlertCode = styled.code`
  background-color: #f1f1f1;
  padding: 0.2rem 0.4rem;
  border-radius: 0.2rem;
`;

const CognitoConfigAlert = () => {
  if (configValidation.isValid) {
    return null;
  }

  return (
    <AlertContainer>
      <AlertTitle>Cognito Configuration Error</AlertTitle>
      <p>
        The application cannot connect to Amazon Cognito due to missing or invalid configuration:
      </p>
      <AlertList>
        {configValidation.errors.map((error, index) => (
          <AlertItem key={index}>{error}</AlertItem>
        ))}
      </AlertList>
    </AlertContainer>
  );
};

export default CognitoConfigAlert;
